import { trpc } from "@/lib/trpc";
import { toast } from "sonner";

export const useAcceptInvitationMutation = (
    onSuccess?: (data: any, variables: any) => void,
    onError?: (error: any) => void
) => {
    return trpc.invitations.accept.useMutation({
        onSuccess: (data, variables) => {
            if (onSuccess) onSuccess(data, variables);
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            } else {
                toast.error(error.message || "Failed to accept invitation");
            }
        },
    });
};

export const useCreateInvitationMutation = (
    setOpen?: (open: boolean) => void,
    onSuccess?: () => void
) => {
    const utils = trpc.useUtils();
    return trpc.invitations.create.useMutation({
        onSuccess: async () => {
            utils.invitations.findMany.invalidate();
            utils.invitations.findPending.invalidate();
            if (setOpen) setOpen(false);
            if (onSuccess) onSuccess();
            toast.success("Invitation sent successfully");
        },
        onError: (error: any) => {
            toast.error(error.message || "Failed to send invitation");
        },
    });
};

export const useCancelInvitationMutation = () => {
    const utils = trpc.useUtils();
    return trpc.invitations.cancel.useMutation({
        onSuccess: async () => {
            utils.invitations.findMany.invalidate();
            utils.invitations.findPending.invalidate();
            toast.success("Invitation cancelled");
        },
        onError: (error: any) => {
            toast.error(error.message || "Failed to cancel invitation");
        },
    });
};

export const useResendInvitationMutation = () => {
    const utils = trpc.useUtils();
    return trpc.invitations.resend.useMutation({
        onSuccess: async () => {
            utils.invitations.findMany.invalidate();
            utils.invitations.findPending.invalidate();
            toast.success("Invitation resent successfully");
        },
        onError: (error: any) => {
            toast.error(error.message || "Failed to resend invitation");
        },
    });
};

export const useCleanupExpiredInvitationsMutation = () => {
    const utils = trpc.useUtils();
    return trpc.invitations.cleanup.useMutation({
        onSuccess: async (count) => {
            utils.invitations.findMany.invalidate();
            utils.invitations.findPending.invalidate();
            toast.success(`Cleaned up ${count} expired invitation(s)`);
        },
        onError: (error: any) => {
            toast.error(error.message || "Failed to cleanup invitations");
        },
    });
};

